<template>
  <div class="sscontainer-menu-footer outils"><h3>Outils</h3>
    <ul class="menu-footer">
      <li>
        <router-link
          :to="{name: 'Contact'}"
          target="_blank"
          title="Pour nous contacter">
          Contactez-nous
        </router-link>
      </li>
      <!--li><a href="#" title="Voir le plan du site">Plan du site</a></li-->
      <li>
        <router-link
          :to="{name: 'FAQ'}"
          target="_blank"
          title="Voir notre foire aux questions">
          FAQ
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'footer-menus-tools',
}
</script>
